import { SubSectionLine, SubSectionLineObject } from '../types';

export const isSubSectionLineObject = (line: SubSectionLine): line is SubSectionLineObject =>
    typeof line === 'object' && line !== null && 'name' in line;
